import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Text,
} from "@chakra-ui/react";
import ConnectTools from "../../Assistants/ConnectTools";
import FormFields from "../../Assistants/FormFields";
import WebhookAndIntentFields from "../../Assistants/WebhookAndIntentFields";

const SectionHeader = ({ title, subtitle }) => (
  <AccordionButton px={0} py={3} _hover={{ bg: "transparent" }}>
    <Box flex={1} textAlign="left">
      <Text fontWeight="semibold" fontSize="sm">{title}</Text>
      {subtitle && <Text fontSize="xs" color="gray.500" mt={0.5}>{subtitle}</Text>}
    </Box>
    <AccordionIcon />
  </AccordionButton>
);

const ToolsTab = ({ assistantId, linkAssistantTools, setLinkAssistantTools, getAssistantTool }) => {
  return (
    <Accordion allowMultiple defaultIndex={[0, 1, 2, 3]}>
      {/* CRM Synchronization */}
      <AccordionItem border="none" borderBottom="1px solid" borderColor="gray.100">
        <SectionHeader
          title="CRM Synchronization"
          subtitle="Automatically sync data directly to your CRM."
        />
        <AccordionPanel px={0} pb={4}>
          <Text fontSize="sm" color="gray.400" fontStyle="italic">
            Configure CRM sync in the full settings (coming soon in this view).
          </Text>
        </AccordionPanel>
      </AccordionItem>

      {/* Lead Capture Forms */}
      <AccordionItem border="none" borderBottom="1px solid" borderColor="gray.100">
        <SectionHeader
          title="Lead Capture Forms"
          subtitle="Trigger forms during conversations."
        />
        <AccordionPanel px={0} pb={4}>
          <FormFields assistantId={assistantId} />
        </AccordionPanel>
      </AccordionItem>

      {/* Other Tools */}
      <AccordionItem border="none" borderBottom="1px solid" borderColor="gray.100">
        <SectionHeader
          title="Other Tools"
          subtitle="Connect external apps and APIs."
        />
        <AccordionPanel px={0} pb={4}>
          <ConnectTools
            assistantId={assistantId}
            linkAssistantTools={linkAssistantTools}
            getAssistantTool={getAssistantTool}
          />
        </AccordionPanel>
      </AccordionItem>

      {/* Automation & Routing */}
      <AccordionItem border="none">
        <SectionHeader
          title="Automation & Routing"
          subtitle="Webhooks, intents, and conversation settings."
        />
        <AccordionPanel px={0} pb={4}>
          <WebhookAndIntentFields assistantId={assistantId} />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default ToolsTab;
